<template>
  <section>
    <b-overlay :show="redirect" rounded="sm">
      <b-button  variant="dark" @click="loginSubmit">
        {{ $t("START_IDENTIFICATION") }}
      </b-button>
    </b-overlay>
  </section>
</template>
<script>
export default {
  props: ["link_uuid"],
  data() {
    return {
      methods: [],
      authentication_method: null,
      loading: false,
      options: [],
      redirect: false
    };
  },
  methods: {
    setLoading(value) {
      this.loading = value;
      this.$emit("loading", value);
    },
    authenticatedDone(link_token) {
      this.$emit("authenticated", link_token);
    },
    loginSubmit: function() {
      this.loading = true;
      let self = this;
      if (this.email !== "") {
        self.$emit("loading", true);
        this.$http
          .post(this.user.hostname + "/message/link/authenticate", {
            link_uuid: this.link_uuid,
            method: ""
          })
          .then(function(result) {
            self.loading = false;
            self.redirect = true;
            window.location.href = result.data.request_url;
          })
          .catch(function() {
            self.$emit("loading", false);
            self.loading = false;
          });
      } else {
        self.$emit("loading", false);
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted: function() {
  },
};
</script>
<style></style>
